var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ButtonClose",on:{"~click":function($event){return _vm.clickBtn($event)}}},[_c('img',{attrs:{"src":require(("@images/modal/" + _vm.locale + "/btn_close.png")),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }